import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Alert } from 'bootstrap-italia';
import { IGenericAlert } from 'src/app/model/generic-messages.model';
import { MessageManagerMessageTypeEnum } from 'src/app/shared/services/messages/message.manager.service';

@Component({
  selector: 'app-generic-alert',
  templateUrl: './generic-alert.component.html',
  styleUrls: ['./generic-alert.component.scss'],
})
export class GenericAlertComponent implements OnInit {
  @Input() configAlert: IGenericAlert = {
    id: 'testAlert',
  };
  @Output() closeEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  genericMessageType = MessageManagerMessageTypeEnum;

  ngOnInit() {
    if (this.configAlert.dismissTime) {
      this.closeAlertAfter(this.configAlert.dismissTime);
    }
  }

  closeAlert() {
    const alertRef = document.getElementById(this.configAlert.id);
    if (alertRef) {
      const alert = new Alert(alertRef);
      alert.close();
      this.closeEvent.emit(true);
    }
  }

  closeAlertAfter(ms: number) {
    setTimeout(() => {
      this.closeAlert();
    }, ms);
  }
}
